import {
  CREATE,
  DELETE,
} from 'react-admin'

export function request(apiUrl, type, params) {
  let url = apiUrl + '/admin/auth'
  let options = {}

  switch (type) {
    case 'LOGIN':
      options.method = 'POST'
      options.data = params.data
      break
    case 'REFRESH':
      url += '/refresh'
      options.method = 'POST'
      options.data = params.data
      break
    case CREATE:
      url += '/register'
      options.method = 'POST'
      options.data = params.data
      break
    case DELETE:
      options.method = 'DELETE'
      break
    default:
      break
  }
  return {url, ...options}
}

export function response(res, type, params) {
  let ret = {}
  const {data} = res

  switch (type) {
    default:
      if (data) ret = {data}
      break
  }
  return ret
}
